import Dialog from '@mui/material/Dialog';

interface Props {
  deletePost: () => void;
  onClose: () => void;
}

export const DeletePostModal = ({
  deletePost, onClose,
}: Props) => (
  <Dialog
    open
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <div className="p-6">
      <h1 className="text-lg font-bold border-b pb-2" id="alert-dialog-title">Are you sure you want to delete this post?</h1>
      <div>
        This action will delete this post and all of its credits.
        If you only want to remove the post from a profile, delete the corresponding credit.
        <br />
        <br />
        Deleting a post is permanent, it cannot be reimported.
      </div>
      <div className="text-right mt-5">
        <button type="button" onClick={onClose} className="btn-secondary-outlined mr-2">
          Cancel
        </button>
        <button type="button" onClick={deletePost} className="btn-primary">
          Delete
        </button>
      </div>
    </div>
  </Dialog>
);
